// media
import { useEffect, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";

import { GetUserForm } from "../../services/srvc-utilities";
import { GetLocalUser, GetLocalBusiness } from "../../services/srvc-auth-user";

import { MediaStats } from "../../services/srvc-media-realm";
import { GetMediaLinx } from "../../services/srvc-store-filecoin";

import { Row, Col, Space } from 'antd';

const actionslist = require('../../data/data-actions-media.json').data

export default function MediaActions(props) {

  const data = props.data;
  console.log(data)
  const {id} = useParams();
  const history = useHistory();

  const usxx = GetUserForm();
  const asset = GetUserForm() === "in" ? GetLocalUser() : GetLocalBusiness();

  const role = data.item.owner.find(x => x.user === asset.usid).role
  console.log (role)
  const actions = actionslist
    .filter(x => x.user.includes(role))
    .filter(x => x.actv);
  
  const [loading, setLoading] = useState(true)
    
  const [stat, setStats] = useState({
    view: 0, like: 0, share: 0, dollar: 0
  })

  useEffect( async () => {
    if (asset){
      const fetchData = async() => {
        
        setLoading(true);
        setStats(data.item.stat)
        setLoading(false);
      }
      fetchData()
    } else {}
  },[]);

  const handleStats = async (codx) => {
    setStats({...stat, [codx]: stat[codx]+1});

    var datx = {media: id}
    if (codx === 'like') datx = {...datx, like: 1}
    if (codx === 'share') datx = {...datx, share: 1}

    const result = await MediaStats({
      "data": datx,
      "user": asset.usid
    })
    // console.log(result)
  }

  const handleAction = async (code) => {
    console.log (code)
    if (code==="view") handleStats(code)
    if (code==="share") handleStats(code)
    if (code==="like")handleStats(code)
    if (code==="dollar") history.push(`/${usxx}/mx/d/${id}`)
    if (code==="xweb") GetMediaLinx({file: data.item.file, name: data.item.media});
    if (code==="edit") history.push(`/${usxx}/mx/e/${id}`)

  }

  return (
    <>

    <Space className="" >
      {actions && actions.map((item, i) => (item.actv ?
        <div className="text-center m-0 p-0 mb-1" key={i}>
          
            <Row justify="center" align="middle" 
              className={`back-color-lite hirich cursor`}
              style={{width:'3.3rem', height:'3.3rem', borderRadius:'50%'}}
              onClick={() => handleAction(item.code)}
            >
              <i className={item.icon}></i>
            </Row>
            <Row justify="center" className="m-0 p-0">
              {stat[item.code] || '-'}
            </Row>

        </div>
      : ''))}

    </Space>

    <div className="border-bottom mt-3"></div>

    </>
  );

}